import './Courses.css'
import MyNavbar from '../../components/navbar/MyNavbar'
import { useState, useEffect } from 'react'
import axios from 'axios'
import Footer from '../../components/footer/Footer'
import { Col, Container, Row, Form } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion';
import { FaSort , FaFilter } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import Alert from 'react-bootstrap/Alert';
import CourseItem from '../../components/course/CourseItem'

function Courses() {
    const [courses, setCourses] = useState([])

    // we use this hook below for save our id from check radio btn
    // we write earliest id for amount this states below and show first on load in articles page section.
    const [sortType, setSortType] = useState('earliest')

    // we use this hook for search bar input
    const [searchKey, setSearchKey] = useState('')

    // we use this hook below for change category of our courses for ex : front-end or back-end.
    const [category, setCategory] = useState('')

    // we use this hook below for change status of our courses for ex : compeleted , recording or pre sell .
    const [courseState, setCourseState] = useState('')

    useEffect(() => {
        // first radio btn new one :
        if (sortType === 'earliest') {
            // we use this function for get our info for ex : new or old articles
            getCoursesByOrder('desc', 'id')
        }
        // second radio btn old one :
        else if (sortType === 'latest') {
            getCoursesByOrder('asc', 'id')
        }
        // third radio btn cheapest one :
        else if (sortType === 'cheapest') {
            getCoursesByOrder('asc', 'mainPrice')
        }
        // forth radio btn expensive one :
        else if (sortType === 'expensivest') {
            getCoursesByOrder('desc', 'mainPrice')
        }
    }, [sortType])

    // this hook below for category section :
    useEffect(() => {
        if (category === 'Front-End')
            getCoursesByCategory('Front-End')
        else if (category === 'Back-End')
            getCoursesByCategory('Back-End')
    }, [category])

    // this hook below for status section :
    useEffect(() => {
        if (courseState === 'completed')
            getCoursesByState('completed')
        else if (courseState === 'presell')
            getCoursesByState('presell')
        else if (courseState === 'recording')
            getCoursesByState('recording')
       
    }, [courseState])
    

    // sortHandler func

    const sortHandler = (e) => {
        setSortType(e.target.id)
    }

    // getArticlesByOrder func

    const getCoursesByOrder = (order, column) => {
        axios.get(`http://localhost/react/api/courses/?order=${order}&column=${column}`)
            .then(response => setCourses(response.data.data))
    }

    // getCoursesByCategory func

    // this function give and save category on category state.
    const getCoursesByCategory = (category) => {
        axios.get(`http://localhost/react/api/courses/?category=${category}`)
            .then(response => setCourses(response.data.data))
    }

    // getCoursesByState func

    const getCoursesByState = (state) => {
        axios.get(`http://localhost/react/api/courses/?state=${state}`)
            .then(response => setCourses(response.data.data))
    }

    // searchInputHandler func

    const searchInputHandler = (e) => {
        setSearchKey(e.target.value)

    }

    // searchButtonHandler func

    const searchButtonHandler = () => {
        axios.get(`http://localhost/react/api/articles/?search=${searchKey}&column=writter`)
            .then(response => setCourses(response.data.data))
    }

    // categoryHandler func

    const categoryHandler = (e) => {
        setCategory(e.target.value)
    }

    // courseStateHandler func

    const courseStateHandler = (e) => {
        setCourseState(e.target.value)
    }


    return (
        <>
            <MyNavbar />

            <Container>
                <div className="searchSection">
                    <h1 className='vidalokaFont'>Courses List</h1>
                    {/* search bar input */}
                    <div className="searchBoxContainer">
                        <button className='searchButton' onClick={searchButtonHandler}>Search :</button>
                        <input className='searchInput' type="text" onChange={searchInputHandler} />
                    </div>
                </div>
                {/* this row below for accordion menu that filtered all articles for ex: reading time or new and old article add to our page */}
                <Row>
                    {/* first col on left , for accordion menu : */}
                    <Col className='col-12 col-lg-3'>
                        <Accordion alwaysOpen className='py-3'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header><FaSort size='20px' /><b>Sort the courses :</b></Accordion.Header>
                                <Accordion.Body>
                                    {/* sort course section : */}
                                    <Form>
                                        {/* first radio btn */}
                                        {/* note : we give name property same to all beacuse we want choose one radio button not all of them */}
                                        <Form.Check
                                            type='radio'
                                            id='earliest'
                                            name='sort'
                                            label='The Newest'
                                            onChange={sortHandler}
                                        />
                                        {/* second radio btn */}
                                        <Form.Check
                                            type='radio'
                                            id='latest'
                                            name='sort'
                                            label='The Oldest'
                                            onChange={sortHandler}
                                        />
                                        {/* third radio btn */}
                                        <Form.Check
                                            type='radio'
                                            id='cheapest'
                                            name='sort'
                                            label='The Cheapest'
                                            onChange={sortHandler}
                                        />
                                        {/* forth radio btn */}
                                        <Form.Check
                                            type='radio'
                                            id='expensivest'
                                            name='sort'
                                            label='The most Expensive'
                                            onChange={sortHandler}
                                        />
                                    </Form>
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>

                        {/* Category section : */}
                        <div className="filterWrapper">
                            <div className="filterIcon">
                                <MdCategory size='20px' />
                                <b>Category :</b>
                            </div>
                            <Form>
                                <Form.Check
                                    type='checkbox'
                                    value='Front-End'
                                    label='Front-End'
                                    onChange={categoryHandler}
                                    checked={category === 'Front-End' ? true : false}
                                />

                                <Form.Check
                                    type='checkbox'
                                    value='Back-End'
                                    label='Back-End'
                                    onChange={categoryHandler}
                                    checked={category === 'Back-End' ? true : false}
                                />
                            </Form>
                        </div>

                         {/* Status section : */}
                        <div className="filterWrapper">
                            <div className="filterIcon">
                                <FaFilter size='20px' />
                                <b> Course status :</b>
                            </div>
                            <Form>
                                {/* completed btn */}
                                <Form.Check
                                    type='switch'
                                    value='completed'
                                    label='Completed'
                                    onChange={courseStateHandler}
                                    checked={courseState === 'completed' ? true : false}
                                />
                                {/* pre sell btn */}
                                <Form.Check
                                    type='switch'
                                    value='presell'
                                    label='Pre sell'
                                    onChange={courseStateHandler}
                                    checked={courseState === 'presell' ? true : false}
                                />
                                {/* recoring btn */}
                                 <Form.Check
                                    type='switch'
                                    value='recording'
                                    label='Recording'
                                    onChange={courseStateHandler}
                                    checked={courseState === 'recording' ? true : false}
                                />
                            </Form>
                        </div>
                    </Col>

                    <Col className='col-12 col-lg-9'>
                        <Row className='row-cols-1 row-cols-md-2 row-cols-xl-3 gy-4 py-3'>
                            {/* second col on right , for our articles : */}
                            {courses.map((course) => (
                                <Col key={course.id}>
                                    <CourseItem {...course} />
                                </Col>
                            ))}
                        </Row>
                        {/* we use this alert for search box that if we write something on search box and we have not on courses show some altert in our page */}
                        {courses.length === 0 &&
                            <Alert className='py-3 gy-4 mt-2' variant='warning'>
                                <p>No course found !!!</p>
                            </Alert>
                        }
                    </Col>
                </Row>


            </Container>
            <Footer />
        </>
    )
}


export default Courses